<template>
    <div id="teaching-page">
        <Card title="Directed Reading Programs">
            <template #description>
                <p>
                    <b>
                        <a
                            class="link"
                            rel="noopener noreferrer"
                            target="_blank"
                            href="https://publish.obsidian.md/uoft-math-drp/Projects/2025-2026/The+Signature+of+a+Knot"
                            >Signatures of Knots</a
                        ></b
                    >: I supervised a group of three undergraduate students
                    learning about signatures of high-dimensional knots and the
                    classification of knots up to concordance.
                </p>
                <p>
                    <b
                        ><a
                            class="link"
                            rel="noopener noreferrer"
                            target="_blank"
                            href="https://publish.obsidian.md/uoft-math-drp/Projects/2024-2025/Topological+K-Theory+and+the+Hopf+Invariant+1+Problem"
                            >Topology K-Theory</a
                        ></b
                    >: I supervised a group of three undergraduate students
                    learning about topological K-theory and the Hopf invariant
                    one problem.
                </p>
            </template>
        </Card>
        <Hairline />
        <Card title="Teaching Assistant Positions">
            <template #description>
                <ul>
                    <li><b>MAT257</b>: Multivariable Calculus on Manifolds</li>
                    <li><b>MAT1300</b>: Graduate Differential Topology</li>
                    <li><b>MAT185</b>: Linear Algebra with Proofs</li>
                    <li><b>MAT186</b>: Calculus 1</li>
                    <li><b>CSC236</b>: Math and Logic for Computer Science</li>
                </ul>
            </template>
        </Card>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Card from "@/components/Card.vue";
import Hairline from "@/components/Hairline.vue";

export default defineComponent({
    components: { Card, Hairline },
});
</script>

<style lang="scss">
@use "@/assets/global";

#teaching-page {
    margin-left: global.$side-margin-width;
    margin-right: global.$side-margin-width;
    margin-bottom: global.$top-margin-width;
}
</style>
